import { DetailTemplate } from "~/components/templates/vod/detail";
import { VodDetailHead } from "~/components/templates/vod/detail/head";

export default function VodDetailPage() {
  return (
    <>
      <VodDetailHead />
      <DetailTemplate />
    </>
  );
}
